/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../../atoms/formEnums/formValidation';
import InputText from '../../atoms/inputText/inputText';
import InputTag from '../../atoms/inputTag/inputTag';
import Label from '../../atoms/label/label';
import LoadFromCatalogButton from '../loadFromRelatedTableButton/loadFromRelatedTableButton';
import { IconType } from '../../atoms/icon/icon';
import { ButtonTheme } from '../../atoms/button/button';
import './formInputObj.scss';
import { isArray, isObject } from 'lodash';

export const FormInputTextType = {
  TEXT: 'text',
  COLOR: 'color',
  TIME: 'time',
  EMAIL: 'email',
  NUMBER: 'number',
  PASSWORD: 'password',
  URL: 'url',
  COLOR_PICKER: 'color_picker',
};

/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormInputObj = (props) => {
  const {
    id,
    name,
    type,
    validation,
    errorText,
    label,
    placeholder,
    helpText,
    value,
    childFields,
    mainField,
    onChange,
    configFile,
    relatedConfigTable,
    defaultValue,
    pattern,
    multiple,
    disabled,
    returnValue,
    inputEnabled,
    selectedValue,
    popupSize
  } = props;

  const childRef = useRef();

  const [valueState, setValueState] = useState(null);
  const [valueMainField,setValueMainField] =useState(null);

  const handleOnCloseLoadFromRelatedTable = (data) => {
    if (data !== undefined) {
      if(Array.isArray(data)){
        data=data[0];
      }
      childRef.current.updateValue((data?data[mainField]:null));
      setValueState(data);
      if(returnValue){
        onChange({ target: { value: data[returnValue] } });
      }
      else
        onChange({ target: { value: data } });
    }
  };
  useEffect(() => {
    if (value !== valueState) {
      setValueState(value);
      if(value && isObject(value)){
        setValueMainField(value[mainField]);
        childRef.current.updateValue(value[mainField]);
      }else if(value){
        setValueMainField(value);
        childRef.current.updateValue(value);
      }else{
        setValueMainField("");
      }
    }else{
      setValueMainField("");
    }
  }, [value]);

  return (
    <div className={`form-group row text-${validation}`}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className="col-sm-8">
        {mainField &&  
            <InputText
              id={id}
              name={mainField}
              ref={childRef}
              type={type}
              className={'form-input-text__input'}
              placeholder=""
              value={valueMainField}
              onChange={onChange}
              disabled={(inputEnabled==false)}
            />
          }
        { relatedConfigTable !== undefined
          && (
          <LoadFromCatalogButton
            id={`${id}-button`}
            onClose={handleOnCloseLoadFromRelatedTable}
            label={label}
            configFile={relatedConfigTable}
            buttonText=""
            icon={IconType.SEARCH}
            buttonTheme={ButtonTheme.INFO}
            disabled={disabled}
            selectedValue={[value]}
            popupSize={popupSize?popupSize:null}
          />
          )}
        { (validation === FormValidation.ERROR || validation === FormValidation.WARNING)
          && (
            <small className="form-text">{errorText}</small>
          )}
      </div>
    </div>
  );
};

FormInputObj.propTypes = {
  /**
   * id of input field
   */
  id: PropTypes.string,
  /**
   * Name of input field
   */
  name:  PropTypes.string,
  /**
   * HTML input type, it is a FormInputTypes.TEXT_INPUT enum
   */
  type: PropTypes.oneOf(Object.values(FormInputTextType)),
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Placeholder inside the HTML input
   */
  placeholder: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({}),
  /**
   * Confinguration file to create a table
   */
  relatedConfigTable: PropTypes.shape({}),
  /**
   * Default value
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

FormInputObj.defaultProps = {
  id: '',
  type: FormInputTextType.TEXT,
  errorText: '',
  label: '',
  placeholder: '',
  helpText: '',
  value: null,
  onChange: () => {},
  configFile: undefined,
  relatedConfigTable: undefined,
  defaultValue: '',
};

export default FormInputObj;
